import slice from './Developer.slice';

const { reducer } = slice;
export { reducer as DeveloperReducer };
export { saga as DeveloperSaga } from './Developer.sagas';